import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { AddressDetailsFormComponent } from './address-details-form.component';

export const ngxAddressDetailsFormModule = angular.module('ngxAddressDetailsFormModule', [])
	.directive('ngxAddressDetailsForm', downgradeComponent({ component: AddressDetailsFormComponent }))
	.name;
